module.exports = __webpack_public_path__ + "img/home3.a2677392.png";